import { Icon } from "@iconify/react";
import React, { useContext } from "react";
import {
  KameleonIconContext,
  KameleonIconProps,
  iconMapping,
  IconLibrary,
} from ".";

export const KameleonIcon: React.FC<KameleonIconProps> = ({
  name,
  ...props
}) => {
  if (!name) return null;

  const currentLibrary =
    useContext(KameleonIconContext) ?? IconLibrary.MaterialSymbols;

  if (!Object.values(IconLibrary).includes(currentLibrary)) {
    // eslint-disable-next-line no-console
    console.warn(
      `${currentLibrary} font set doesn't exist. Add this to @kameleon-commons/IconLibrary`
    );
  }

  const iconKey = iconMapping[name]?.[currentLibrary];
  return <Icon icon={iconKey ?? name} {...props} />;
};
